import { useContext } from "react";
import { Container } from "..";
import jiffy from "../../assets/img/Jiffyb.png";
// import logo from "../../assets/img/logo.png";
import { Form } from "../Form/index";
import { ThemeContext } from "../context";
import {
  CopySpan,
  JiffyCopyRight,
  JiffyCopyRightContent,
  JiffyEmailUs,
  JiffyFooter,
  JiffyFooterHeading,
  JiffyFooterLinks,
  JiffyFooterLinksContainer,
  JiffyFooterLogo,
  JiffyFooterMenu,
  JiffyFooterNewsLetterHeading,
  JiffyFooterNewsLetterParagrah,
  JiffyFooterNewsletter,
  JiffyLogoContent,
  JiffyMission,
  Link,
} from "./Footer.elements";
import { Link as ReactScrollLink } from "react-scroll";

export const Footer = () => {
  const entries = [
    {
      id: 1,
      type: "email",
      placeholder: "Enter Email Address",
      typePlaceholder: "Select preferred type",
    },
  ];

  const { rooTheme } = useContext(ThemeContext);

  return (
    <div>
      <Container>
        <JiffyFooter rooTheme={rooTheme}>
          <JiffyLogoContent>
            <JiffyFooterLogo src={rooTheme === "dark" ? jiffy : jiffy} />
            <JiffyMission>
              Logistics Gateways Platform for your sendables
            </JiffyMission>
          </JiffyLogoContent>

          <JiffyFooterLinksContainer>
            <div>
              <JiffyFooterHeading>Product</JiffyFooterHeading>
              <JiffyFooterMenu rooTheme={rooTheme}>
                <JiffyFooterLinks>
                  <ReactScrollLink
                    to={"For Business"}
                    spy={true}
                    smooth={true}
                    offset={-80}
                    duration={1500}
                  >
                    <Link to="/">For Business</Link>
                  </ReactScrollLink>
                </JiffyFooterLinks>
                <JiffyFooterLinks>
                  <ReactScrollLink
                    to={"For Courier"}
                    spy={true}
                    smooth={true}
                    offset={-80}
                    duration={1500}
                  >
                    <Link to="/">For Couriers</Link>
                  </ReactScrollLink>
                </JiffyFooterLinks>
                <JiffyFooterLinks>
                  <ReactScrollLink
                    to={"For you"}
                    spy={true}
                    smooth={true}
                    offset={-70}
                    duration={1500}
                  >
                    <Link to="/">For individuals</Link>
                  </ReactScrollLink>
                </JiffyFooterLinks>
              </JiffyFooterMenu>
            </div>

            <div>
              <JiffyFooterHeading>Legal</JiffyFooterHeading>
              <JiffyFooterMenu rooTheme={rooTheme}>
                <JiffyFooterLinks>
                  <Link to="/">Term Of Service</Link>
                </JiffyFooterLinks>
                <JiffyFooterLinks>
                  <Link to="/">Privacy Policy</Link>
                </JiffyFooterLinks>
              </JiffyFooterMenu>
            </div>

            <div>
              <JiffyFooterHeading>Contact</JiffyFooterHeading>
              <JiffyFooterMenu rooTheme={rooTheme}>
                <JiffyFooterLinks>
                  <a
                    href="https://twitter.com/byjiffy?s=20"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Twitter
                  </a>
                </JiffyFooterLinks>
                <JiffyFooterLinks>
                  <a
                    href="https://www.instagram.com/jiffyhq"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Instagram
                  </a>
                </JiffyFooterLinks>
                <JiffyFooterLinks>
                  <a
                    href="https://www.tiktok.com/@byjiffy?is_from_webapp=1&sender_device=pc"
                    target="_blank"
                    rel="noreferrer"
                  >
                    TikTok
                  </a>
                </JiffyFooterLinks>
                <JiffyEmailUs rooTheme={rooTheme}>
                  <a
                    href="mailto:product@jiffyhq.com"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Email us at: <span>product@jiffyhq.com</span>
                  </a>
                </JiffyEmailUs>
              </JiffyFooterMenu>
            </div>
          </JiffyFooterLinksContainer>

          <JiffyFooterNewsletter>
            <JiffyFooterNewsLetterHeading>
              Subscribe to our Newsletter
            </JiffyFooterNewsLetterHeading>

            <JiffyFooterNewsLetterParagrah rooTheme={rooTheme}>
              Get first hand news about the features and services we offer you
            </JiffyFooterNewsLetterParagrah>

            <Form
              entries={entries}
              // formbg="white"
              formcolor="rgba(30, 30, 30, 0.7)"
              buttonText="Join waitlist"
              opacity={1}
              icon=""
              paddingvals="12px 40px"
            />
          </JiffyFooterNewsletter>
        </JiffyFooter>

        <JiffyCopyRight rooTheme={rooTheme}>
          <JiffyCopyRightContent rooTheme={rooTheme}>
            <CopySpan>&copy;</CopySpan> 2023 Jiffy. All rights reserved
          </JiffyCopyRightContent>
        </JiffyCopyRight>
      </Container>
    </div>
  );
};
